/******************************** Import Package ************************************/
import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

/******************************** Select  ************************************/
export default function SelectValue(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
    defaultValue,
    ...other
  } = props;

  return (
    <FormControl fullWidth variant="outlined" error={!!error}>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        {...other}
      >
        {options.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.title}
          </MenuItem>
        ))}
      </Select>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
